export default __webpack_public_path__ + "static/media/wUMrm.a225a424.png";